import {initializeApp} from 'firebase/app';
import {getAuth} from 'firebase/auth';
import {getFirestore} from 'firebase/firestore';

import {firebaseConfig as prodConfig} from './firebase-config.prod';
import {firebaseConfig as stagingConfig} from './firebase-config.staging';
import {firebaseConfig as devConfig} from './firebase-config.dev';

// Initialize Firebase
export const app = initializeApp(
  process.env.NEXT_PUBLIC_ENV === 'production'
    ? prodConfig
    : process.env.NEXT_PUBLIC_ENV === 'staging'
    ? stagingConfig
    : devConfig
);
export const auth = getAuth(app);
export const db = getFirestore(app);

if (typeof window !== 'undefined') {
  (window as any).getAuthToken = (forceRefresh = false) => {
    return auth.currentUser?.getIdToken(forceRefresh);
  };
}
